import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'

import { useArticlesInfiniteQuery } from '../api/get-articles'

type Props = {
  pageType: 'host' | 'guest'
  categoryId: number | null
}

export const useArticlesInfinite = ({ pageType, categoryId }: Props) => {
  const { data, hasNextPage, fetchNextPage } = useArticlesInfiniteQuery({
    pageType,
    categoryId,
  })

  const { articles, articleCategories, isFirstPage } = data
  const { ref, inView } = useInView()

  useEffect(() => {
    if (inView && hasNextPage) {
      void fetchNextPage()
    }
  }, [inView, hasNextPage, fetchNextPage])

  return {
    articles,
    articleCategories,
    ref,
    isFirstPage,
  }
}
